import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { semanticColors, greyScaleColors } from '../../../../Globals/styles';
import WheelInput from '../../../../Common/wheelInput'
import IncrementInput from '../../../../Common/incrementInput'
import Selectpicker from '../../../../Common/selectpicker'
import { employeeFunctions, absenceCodes } from '../../../../Globals/constants'
import Validator from '../../../../Common/validator'
import NumberInput from '../../../../Common/numberInput'

class Employee extends Component {
  constructor(props) {
    super(props);
    let absenceCodesForState = Object.keys(absenceCodes).map((absenceCode) => { return { id: absenceCode, name: absenceCodes[absenceCode] } })
    absenceCodesForState.splice(0, 0, { id: "0", name: "Fraværskode" })
    this.state = {
      absenceCodes: absenceCodesForState,
      selectpickerChildren: this.getFunctionSelectPickerChildren(),
      isShowingAbsence: this.props.employee.absence ? true : false,
      isShowingMileage: this.props.employee.mileage ? true : false,
      checkInCheckOutMode: this.props.checkInCheckOutMode,
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    const { employee } = this.props;
    return (
      nextProps.employee.absence !== employee.absence ||
      nextProps.employee.shack !== employee.shack ||
      nextProps.employee.mileage !== employee.mileage ||
      nextProps.employee.break !== employee.break ||
      nextProps.employee.timeRegistrations !== employee.timeRegistrations ||
      nextState.isShowingAbsence !== this.state.isShowingAbsence ||
      nextState.isShowingMileage !== this.state.isShowingMileage ||
      nextProps.setEmployeeHasAbsence !== this.props.setEmployeeHasAbsence ||
      nextProps.removeEmployeeHasAbsence !== this.props.removeEmployeeHasAbsence ||
      nextProps.toggleShack !== this.props.toggleShack ||
      nextProps.updateEmployeeTimeRegistration !== this.props.updateEmployeeTimeRegistration ||
      nextProps.updateEmployeeAddTimeRegistration !== this.props.updateEmployeeAddTimeRegistration
    )
  }
  getFunctionSelectPickerChildren = () => {
    let selectpickerChildren = [];
    employeeFunctions.forEach((employeeFunction, index) => {
      // eslint-disable-next-line
      if (index == 0) {
        selectpickerChildren.push(
          <option
            key={index}
            value={0}>
            Funktion
          </option>
        )
      }
      selectpickerChildren.push(
        <option
          key={index + 1}
          value={employeeFunction.value}>
          {employeeFunction.text}
        </option>
      )
    })
    return selectpickerChildren
  };
  isEmployeeActive = () => {
    const { employee: { timeRegistrations, absence, shack, mileage } } = this.props;
    let totalHours = 0
    timeRegistrations.forEach((t) => {
      totalHours += t.hours
    })
    return (absence != null || totalHours !== 0 || shack || mileage !== 0)
  };
  setIsShowingAbsence = () => {
    this.setState({
      isShowingAbsence: true
    })
  };
  setIsShowingMileage = () => {
    this.setState({
      isShowingMileage: true
    })
  };
  round50up = (x) => {
    return Math.round(x / 50) * 50;
  }
  round15up = (x) => {
    return Math.round(x / 15) * 15;
  }
  addHoursMinutesToDate(date, hours, minutes) {
    var d2 = new Date(date);
    d2.setHours(date.getHours() + hours);
    d2.setMinutes(date.getMinutes() + minutes);
    return d2
  }
  stripAndCreateDate = (string) => {
    string = string.replace(':', '')
    string = string.replace(',', '')
    string = string.replace('.', '')
    string = string.replace(' ', '')
    var start_hour = string.slice(0, -2);
    var start_minutes = string.slice(-2);
    return new Date(0, 0, 0, start_hour, start_minutes, 0);
  }
  dateToString = (date) => {
    let min = date.getMinutes();
    // eslint-disable-next-line
    if (min == 0) {
      min = "00"
    }
    let hours = date.getHours();
    if (hours < 10) {
      hours = "0" + hours
    }
    return hours + ":" + min
  }
  calculateHourDifference = (checkIn, checkOut) => {
    var startDate = this.stripAndCreateDate(checkIn);
    var endDate = this.stripAndCreateDate(checkOut);
    var diff = endDate.getTime() - startDate.getTime();
    var hours = Math.floor(diff / 1000 / 60 / 60);
    diff -= hours * 1000 * 60 * 60;
    var minutes = Math.floor(diff / 1000 / 60);
    if (hours < 0) hours = 24 + hours;
    minutes = (minutes / 60) * 100
    minutes = this.round50up(minutes)
    // eslint-disable-next-line
    if (minutes == 100) {
      minutes = 0
      hours += 1
    }
    return parseFloat(hours + '.' + minutes)
  }
  filterOnlyDigits = (s) => {
    return s.replace(/[^0-9.,:]/g, "")
  }
  rounxs = (x) => {
    x = x.replace('.', '')
    var end_minutes = x.slice(-2);
    var end_hour = x.slice(0, -2);
    var minutes = this.round15up(end_minutes)
    // eslint-disable-next-line
    if (minutes == 0) minutes = '00'
    // eslint-disable-next-line
    else if (minutes >= 60) {
      minutes = '00'
      end_hour = parseInt(end_hour, 10) + 1
      if (end_hour < 10) {
        end_hour = '0' + end_hour
      }
      end_hour = end_hour + ':'
    }
    if (parseInt(end_hour) >= 24) { end_hour = '00:' }
    return end_hour + minutes
  }
  setcheckIn = (index, timeRegistration, txt, round) => {
    const { updateEmployeeTimeRegistration, updateEmployeeBreak } = this.props;
    let input = this.filterOnlyDigits(txt.target.value)
    if (round)
      input = this.rounxs(input)
    let val = 0;
    if (timeRegistration.checkOut) {
      val = this.calculateHourDifference(input, timeRegistration.checkOut)
    }
    // eslint-disable-next-line
    if (input == "00") {
      input = undefined
      val = 0
    }
    updateEmployeeTimeRegistration(index, 'checkIn', input)
    updateEmployeeTimeRegistration(index, 'hours', val)

    if (!timeRegistration.checkOut && round && this.hasOneFunctionReg()) {
      updateEmployeeBreak(0.5)
      if (input !== undefined) {
        var checkin = this.stripAndCreateDate(input)
        var checkout = this.addHoursMinutesToDate(checkin, 8, 0)
        var che = this.dateToString(checkout)
        val = 8
        updateEmployeeTimeRegistration(index, 'checkOut', this.filterOnlyDigits(che))
        updateEmployeeTimeRegistration(index, 'hours', val)
      }
    }
  }
  setcheckOut = (index, timeRegistration, txt, round) => {
    const { updateEmployeeTimeRegistration, updateEmployeeBreak } = this.props;
    let input = this.filterOnlyDigits(txt.target.value)
    if (round)
      input = this.rounxs(input)
    let val = 0;
    if (timeRegistration.checkIn) {
      val = this.calculateHourDifference(timeRegistration.checkIn, input)
    }
    // eslint-disable-next-line
    if (input == "00") {
      input = undefined
      val = 0
    }
    updateEmployeeTimeRegistration(index, 'checkOut', input)
    updateEmployeeTimeRegistration(index, 'hours', val)

    if (!timeRegistration.checkIn && round && this.hasOneFunctionReg()) {
      updateEmployeeBreak(0.5)
      if (input !== undefined) {
        var checkOut = this.stripAndCreateDate(input)
        var checkIn = this.addHoursMinutesToDate(checkOut, -8, 0)
        var che = this.dateToString(checkIn)
        val = 8
        updateEmployeeTimeRegistration(index, 'checkIn', this.filterOnlyDigits(che))
        updateEmployeeTimeRegistration(index, 'hours', val)
      }
    }
  }
  hasOneFunctionReg = () => {
    const { employee } = this.props
    // eslint-disable-next-line
    return employee.timeRegistrations.length == 1
  }
  updateBreak = (breakHour) => {
    const { updateEmployeeBreak } = this.props;
    updateEmployeeBreak(breakHour)
  }
  render() {
    const { employee, setEmployeeHasAbsence, toggleShack, setMileage,
      updateEmployeeTimeRegistration, removeEmployeeHasAbsence,
      updateEmployeeAddTimeRegistration, disabled } = this.props;
    let maxValue = 0
    employee.timeRegistrations.forEach((t) => {
      if (t.hours > maxValue) {
        maxValue = t.hours
      }
    })
    let timeRegistrationNodes = employee.timeRegistrations.map((timeRegistration, index) => {
      return (
        <div style={styles.innerRow} key={index}>
          {this.state.checkInCheckOutMode ?
            <div>
              <div className="col-xs-3" style={styles.firstColumn}>
                <Validator
                  // eslint-disable-next-line
                  isValid={!(timeRegistration.hours + timeRegistration.nightHours !== 0 && (!timeRegistration.employeeFunction || timeRegistration.employeeFunction == "0"))}
                  msg="Skal vælges, hvis timer er angivet"
                >
                  <select
                    value={timeRegistration.employeeFunction}
                    style={styles.select}
                    onChange={(evt) => updateEmployeeTimeRegistration(index, 'employeeFunction', evt.target.value)}>
                    {this.state.selectpickerChildren}
                  </select>
                </Validator>
              </div>
              <div className="col-xs-3">
                <input
                  type="time"
                  style={styles.timeInput}
                  value={timeRegistration.checkIn ? timeRegistration.checkIn : ''}
                  onChange={(evt) => this.setcheckIn(index, timeRegistration, evt, false)}
                  onBlur={(evt) => this.setcheckIn(index, timeRegistration, evt, true)}
                />
              </div>
              <div className="col-xs-3">
                <input
                  type="time"
                  style={styles.timeInput}
                  value={timeRegistration.checkOut ? timeRegistration.checkOut : ''}
                  onChange={(evt) => this.setcheckOut(index, timeRegistration, evt, false)}
                  onBlur={(evt) => this.setcheckOut(index, timeRegistration, evt, true)}
                />
              </div>
              <div className="col-xs-3">
                <IncrementInput
                  minValue={0}
                  maxValue={maxValue ? maxValue - employee.break : 0}
                  interval={0.5}
                  defaultValue={timeRegistration.nightHours}
                  onChange={(val) => updateEmployeeTimeRegistration(index, 'nightHours', val)}
                />
              </div>
            </div>
            :
            <div>
              <div className="col-xs-3" style={styles.firstColumn}>
                <Validator
                  // eslint-disable-next-line
                  isValid={!(timeRegistration.hours + timeRegistration.nightHours !== 0 && (!timeRegistration.employeeFunction || timeRegistration.employeeFunction == "0"))}
                  msg="Skal vælges, hvis timer er angivet"
                >
                  <select
                    value={timeRegistration.employeeFunction}
                    style={styles.select}
                    onChange={(evt) => updateEmployeeTimeRegistration(index, 'employeeFunction', evt.target.value)}>
                    {this.state.selectpickerChildren}
                  </select>
                </Validator>
              </div>
              <div className="col-xs-3">
                <WheelInput
                  minValue={0}
                  maxValue={74}
                  interval={0.5}
                  defaultValue={timeRegistration.hours}
                  onChange={(val) => updateEmployeeTimeRegistration(index, 'hours', val)}
                  overLayColor={wheelInputOverlayColor}
                />
              </div>
              <div className="col-xs-3">
                <WheelInput
                  minValue={0}
                  maxValue={74}
                  interval={0.5}
                  defaultValue={timeRegistration.nightHours}
                  onChange={(val) => updateEmployeeTimeRegistration(index, 'nightHours', val)}
                  overLayColor={wheelInputOverlayColor}
                />
              </div>
              <div className="col-xs-3">
                <button
                  className="btn btn-defualt waves-btn"
                  style={styles.addTimeRegistrationButton}
                  onClick={updateEmployeeAddTimeRegistration}
                >
                  Tilføj funktion
                  <i className="fa fa-arrow-down" aria-hidden="true" style={styles.arrowDown}></i>
                </button>
              </div>
            </div>
          }
        </div>
      )
    })

    return (
      <div style={[styles.container, this.isEmployeeActive() && styles.containerActive, disabled && styles.containerDisabled]}>
        <div style={styles.row}>
          <div style={styles.smallInnerRow}>
            <div className="col-xs-3" style={styles.firstColumn}>Navn</div>
            <div className="col-xs-3">Fravær</div>
            <div className="col-xs-3">Skurpenge</div>
            <div className="col-xs-3">Kørsel i km</div>
          </div>
          <div style={styles.innerRow}>
            <div className="col-xs-3" style={styles.firstColumn}>{employee.name}</div>
            <div className="col-xs-3">
              {
                this.state.isShowingAbsence ?
                  <Selectpicker
                    onChange={(val) => {
                      // eslint-disable-next-line
                      if (val == "0")
                        removeEmployeeHasAbsence()
                      else
                        setEmployeeHasAbsence(val)
                    }}
                    items={this.state.absenceCodes}
                    defaultValue={employee.absence ? employee.absence.absenceCode : "0"}
                  />
                  :
                  <i
                    style={styles.check}
                    className="fa fa-square-o"
                    aria-hidden="true"
                    onClick={this.setIsShowingAbsence}
                  />
              }
            </div>
            <div className="col-xs-3">
              {!employee.shack ?
                <i
                  style={styles.check}
                  className="fa fa-square-o waves-icon"
                  aria-hidden="true"
                  onClick={() => toggleShack(true)}
                />
                :
                <i
                  style={styles.check}
                  className="fa fa-check-square-o waves-icon"
                  aria-hidden="true"
                  onClick={() => toggleShack(false)}
                />
              }

            </div>
            <div className="col-xs-3">
              {
                this.state.isShowingMileage ?
                  <NumberInput
                    onChange={setMileage}
                    value={employee.mileage}
                    defaultValue={employee.mileage}
                    shouldNotCallOnChangeOnMount={true}
                  />
                  :
                  <i
                    style={styles.check}
                    className="fa fa-square-o"
                    aria-hidden="true"
                    onClick={this.setIsShowingMileage}
                  />
              }

            </div>
          </div>
        </div>
        <div style={styles.row}>
          <div style={styles.smallInnerRow}>
            <div className="col-xs-3" style={styles.firstColumn}>Funktion</div>
            <div className="col-xs-3">
              {this.state.checkInCheckOutMode ? "Start-tid" : "Dag"}
              {this.state.checkInCheckOutMode ?
                <i className="fa fa-clock-o" aria-hidden="true"
                  style={styles.clock}>
                </i> : null}
            </div>
            <div className="col-xs-3">
              {this.state.checkInCheckOutMode ? "Slut-tid" : "Nat/Overtid"}
              {this.state.checkInCheckOutMode ?
                <i className="fa fa-clock-o" aria-hidden="true"
                  style={styles.clock}>
                </i> : null}
            </div>
            {this.state.checkInCheckOutMode ?
              <div className="col-xs-3">
                {"Heraf Nat/ Overtid"}
              </div>
              : null}
          </div>
          {timeRegistrationNodes}
          {this.state.checkInCheckOutMode ?
            <div style={{ height: 60 }}>
              <div className="align-items-end">
                <div className="col-xs-3 col-xs-offset-9">
                  Pause
            </div>
              </div>
              <div className="">
                <div className="col-xs-9">
                  <button
                    className="btn btn-defualt waves-btn"
                    style={styles.addTimeRegistrationButton}
                    onClick={updateEmployeeAddTimeRegistration}
                  >
                    Tilføj funktion
                <i className="fa fa-arrow-down" aria-hidden="true" style={styles.arrowDown}></i>
                  </button>
                </div>
                <div className="col-xs-3">
                  <IncrementInput
                    minValue={0}
                    maxValue={maxValue}
                    interval={0.5}
                    defaultValue={employee.break}
                    onChange={this.updateBreak}
                  />
                </div>
              </div>
            </div>
            : null}
          {!disabled ? null :
            <div style={{ padding: 10, color: 'grey' }}>
              Bruger mangler at godkende / bekræfte oplysninger i Arbejdsmiljø-fanen
            </div>
          }
        </div>
      </div>
    );
  }
}

var wheelInputOverlayColor = 'linear-gradient(to right, rgba(238,238,238,1) 2%,rgba(238,238,238,1) 6%,rgba(238,238,238,0) 50%,rgba(238,238,238,1) 92%,rgba(238,238,238,1) 200%)'

var styles = {
  container: {
    width: '100%',
    backgroundColor: greyScaleColors.greyLighter,
    borderLeft: '2px solid ' + greyScaleColors.greyLighter,
    borderRadius: '2px'
  },
  containerActive: {
    borderLeft: '2px solid ' + semanticColors.info
  },
  containerDisabled: {
    borderLeft: '2px solid ' + semanticColors.danger,
    pointerEvents: 'none'
  },
  row: {
    marginBottom: '12px',
    textAlign: 'center'
  },
  smallInnerRow: {
    fontSize: '12px',
    height: '20px',
  },
  innerRow: {
    height: '40px',
  },
  firstColumn: {
    textAlign: 'left',
    paddingRight: '0',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },
  select: {
    '-webkit-appearance': 'none',
    '-moz-appearance': 'none',
    '-webkit-border-radius': '0px',
    boxShadow: '0 1px 2px rgba(0,0,0,0.2) inset, 0 -1px 0 rgba(0,0,0,0.05) inset',
    backgroundColor: 'white',
    border: 'none',
    cursor: 'pointer',
    width: '100%',
    height: '35px',
    padding: '5px',
  },
  timeInput: {
    '-webkit-appearance': 'none',
    lineHeight: '35px',
    width: ' 100%',
    border: 'none',
    textAlign: 'center',
    cursor: 'pointer',
    display: 'block',
  },
  addTimeRegistrationButton: {
    backgroundColor: greyScaleColors.greyLighter,
    fontWeight: '600',
    float: 'left',
    marginLeft: '12px'
  },
  arrowDown: {
    marginLeft: '10px'
  },
  clock: {
    marginLeft: '10px',
    fontSize: '16px'
  },
  check: {
    width: '35px',
    height: '35px',
    lineHeight: '35px',
    cursor: 'pointer',
    fontSize: '24px',
    overflow: 'initial'
  },
  height100: {
    height: '100%'
  }
}
Employee.propTypes = {
  employee: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    break: PropTypes.number,
    absence: PropTypes.shape({
      date: PropTypes.object.isRequired,
      absenceCode: PropTypes.string
    }),
    shack: PropTypes.bool.isRequired,
    mileage: PropTypes.number.isRequired,
    timeRegistrations: PropTypes.arrayOf(PropTypes.shape({
      hours: PropTypes.number.isRequired,
      nightHours: PropTypes.number.isRequired,
      employeeFunction: PropTypes.string
    })).isRequired
  }).isRequired,
  setEmployeeHasAbsence: PropTypes.func.isRequired,
  removeEmployeeHasAbsence: PropTypes.func.isRequired,
  toggleShack: PropTypes.func.isRequired,
  setMileage: PropTypes.func.isRequired,
  updateEmployeeTimeRegistration: PropTypes.func.isRequired,
  updateEmployeeAddTimeRegistration: PropTypes.func.isRequired
};
export default Radium(Employee)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/Employees/employee.jsx